import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import idearLogo from 'assets/images/logo.svg'
import logoXs from 'assets/images/logo-xs.png'
import asobiButton from 'assets/images/button.svg'
import email from 'assets/icons/envelope.png'
import menuIcon from 'assets/icons/hamburger.png'
import idearTitle from 'assets/icons/title-idear.svg'
import idearMenu from 'assets/icons/menu.svg'
import idearShield from 'assets/icons/shield.svg'
import idearArrowUp from 'assets/icons/arrow-up.svg'
import idearArrowRight from 'assets/icons/arrow-right.svg'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { setUserData, setWalletData, userData } from 'storage/reducers/parentReducer'
import OutsideClickHandler from 'components/Utils/OutsideClickHandler'
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types'
import { blankUser } from 'assets'
import Swal from 'sweetalert2'
import './nav.scss'
import 'styles/swalAlert.scss'
import '../../../pages/home/i18n';

const NavBarFullNew = ({ transparent = false, position = 'fixed' }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t, i18n, ready } = useTranslation()
  const [openToogle, setOpenToogle] = useState(false)
  const [bgLogo, setBgLogo] = useState(idearLogo)
  const location = useLocation()
  const currentPath = location.pathname
  const userState = useSelector((state) => state.parent)
  const {
    user: { userData: currentUserData }
  } = userState
  const isLogin = false
  const getCurrentLang = localStorage.getItem('i18nextLng') || '';
  
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 600) {
        setBgLogo(logoXs)
      } else {
        // setBgAudition(userAudition)
      }
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  const onClickAbout = async () => {    
    navigate(`/about`)
  }

  const onClickRoadmap = async () => {
    navigate(`/roadmap`)
  }

  const onClickOurTeam = async () => {
    navigate(`/our-team`)
  }

  const onClickTraining = async () => {
    currentPath.includes('claim') ? window.open('/training/owned', '_self') : navigate(`/training/owned`)    
  }
  
  const onClickPrivacy = async () => {
    navigate(`/privacy-policy`)
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const logout = () => {
    Swal.fire({
      title: 'Are you sure want to logout?',
      text: 'Tap "Cancel" if you want to recheck again',
      icon: 'question',
      reverseButtons: true,
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      color: '#324340',
      confirmButtonColor: '#54F49E',
      cancelButtonColor: '#54F49E',
      confirmButtonText: 'Logout',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          setWalletData({
            isLoggedIn: false,
            walletAddress: ''
          })
        )
        dispatch(setUserData(userData))
        localStorage.removeItem('__it__')
        navigate('/')
        torusInstace.logout()
      } else if (result.isDenied) {
        Swal.close()
      }
    })
  }

  return (
    <div className={`navbar bg-[#9E62DE] top-0 shadow-md z-50 w-full md:h-[90px] md:fixed z-[1000]`}>
      <div className="nav-wrapper h-full md:pl-32 md:pr-32">
        <div className="flex items-center justify-between h-full">
          <div className="flex items-center">
            <div className="flex-row flex w-12/12 items-center cursor-pointer" onClick={() => navigate('/')}>
              <span className="asobi-logo">
                <img src={bgLogo} className="md:h-[50px]" alt="logo" />
              </span>
            </div>
          </div>
          {isLogin ? (
            <div className="hidden md:flex h-full">
              <div className="w-full hidden md:flex items-center justify-end">
                <div className="flex items-center space-x-3 flex-row md:space-x-3">
                  <div className="w-[6px] h-[38px] bg-[#E0DDDD] m-auto"></div>
                  <div className="dropdown">
                    <OutsideClickHandler
                      onOutsideClick={() => {
                        setOpenToogle(false)
                      }}>
                      <div className="avatar cursor-pointer m-auto" onClick={() => setOpenToogle(!openToogle)}>
                        <div className="w-[34px] rounded-full mx-2">
                          <img className="rounded-full w-[34px] h-[34px]" src={currentUserData.picture || blankUser} alt="Profile" />
                        </div>
                      </div>
                      {openToogle && (
                        <div className="dropdown-content" onClick={() => setOpenToogle(true)}>
                          <img src={idearArrowUp} className="-mb-[1px]" alt="arrow-up" />
                          <div className="dropdown-item">
                            <div className="menu-item flex p-[10px] justify-between cursor-pointer">
                              <div className="relative my-auto">
                                <div className="flex items-center cursor-pointer m-auto">
                                  <div className="w-[34px] rounded-full mx-2">
                                    <img
                                      className="rounded-full w-[34px] h-[34px]"
                                      src={currentUserData.picture || blankUser}
                                      alt="Profile"
                                    />
                                  </div>
                                </div>
                                <img src={idearShield} className="right-0 bottom-0 absolute" alt="Profile" />
                              </div>
                            </div>
                            <hr className="bg-[#F0F0F0]" />
                            <div
                              className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                              onClick={() => navigate('/profile')}>
                              <div className="font-bold text-[17px] text-[#324340]">PROFILE</div>
                              <img src={idearArrowRight} className="" alt="arrow-right" />
                            </div>
                            <hr className="bg-[#F0F0F0]" />
                            <div
                              className="menu-item flex p-4 hover:bg-gray-100 cursor-pointer rounded-bl-[14px] rounded-br-[14px]"
                              onClick={logout}>
                              <div className="font-bold text-[17px] text-[#324340]">LOGOUT</div>
                            </div>
                          </div>
                        </div>
                      )}
                    </OutsideClickHandler>
                  </div>
                  <img src={idearMenu} className="w-full m-auto cursor-pointer" alt="menu" />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="flex h-full">
                <div className="nav-title mx-6 my-auto max-[600px]:hidden" onClick={onClickAbout}>
                  ABOUT
                </div>
                <div className="nav-title ml-6 my-auto max-md:hidden" onClick={onClickRoadmap}>
                  ROAD MAP
                </div>
                <div className="nav-title ml-6 my-auto max-md:hidden" onClick={onClickOurTeam}>
                  TEAM
                </div>
                <span className="idear-title mx-6 mr-0 my-auto" onClick={onClickTraining}>
                  <div className="asobi-button">
                    <span className="text">{t("button_training")}</span>
                  </div>
                </span>
                {/* <div className="nav-title ml-6 my-auto max-md:hidden" onClick={onClickPrivacy}>
                  PRIVACY & POLICY
                </div> */}
                <div className="flex m-auto language">
                  <LanguageIcon className="lang-icon" />
                  <button className={`button ${getCurrentLang !== 'jp' ? 'active' : ''}`} type="button" onClick={() => changeLanguage('jp')}>
                    JP
                  </button>
                  <span className="devider"> / </span>
                  <button className={`button !mr-2.5 ${!getCurrentLang.includes('en') ? 'active' : ''}`} type="button" onClick={() => changeLanguage('en')}>
                    EN
                  </button>
                </div>
                <br />
                {/* <div className="menu-top nav-email">
                  <img src={email} className="w-10 m-auto" alt="logo" />
                </div> */}
                <div className="nav-menu">
                  <img src={menuIcon} onClick={() => setOpenToogle(!openToogle)} className="w-8 m-auto" alt="logo" />
                </div>
              </div>
              {/* <button
                key="art"
                onClick={onClickAbout}
                className="bg-gradient-to-r from-idear-purple to-idear-green text-white px-6 py-2 rounded-full text-lg font-bold flex flex-row items-center leading-5 w-[114px]">
                <div className="justify-between gap-x-2 text-white text-center w-full">About</div>
              </button>
              <button
                key="art"
                onClick={onClickRoadmap}
                className="bg-gradient-to-r from-idear-purple to-idear-green text-white px-6 py-2 rounded-full text-lg font-bold flex flex-row items-center leading-5 w-[114px]">
                <div className="justify-between gap-x-2 text-white text-center w-full">Roadmap</div>
              </button> */}
            </>
          )}
        </div>
            <OutsideClickHandler
              className="absolute"
              onOutsideClick={() => {
                setOpenToogle(false)
              }}>
                {openToogle && (
                  <div className="dropdown-content" onClick={() => setOpenToogle(true)}>
                    <div className="pr-[-15px] pl-[-15px] py-0">
                      <img src={idearArrowUp} className="-mb-[1px] mr-[-50px]" alt="arrow-up" />
                    </div>
                    <div className="dropdown-item">
                      <div className="nav-claim">                        
                          <div
                            className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                            onClick={() => currentPath.includes('training') ? window.open('/claim', '_self') : navigate('/claim')}>
                            <div className="nav-title-xs" style={{ fontFamily: "Press Start 2P!important" }}>Claim</div>
                            {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                          </div>
                      </div>
                      <div className="nav-other">
                        <div
                          className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                          onClick={() => navigate('/about')}>
                          <div className="nav-title-xs">About</div>
                          {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                        </div>
                        <hr className="bg-[#F0F0F0]" />
                        <div
                          className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                          onClick={() => navigate('/roadmap')}>
                          <div className="nav-title-xs">Roadmap</div>
                          {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                        </div>
                        <hr className="bg-[#F0F0F0]" />
                        <div
                          className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                          onClick={() => navigate('/our-team')}>
                          <div className="nav-title-xs">Team</div>
                          {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                        </div>
                        <hr className="bg-[#F0F0F0]" />
                        <div
                          className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                          onClick={() => currentPath.includes('training') ? window.open('/training/owned', '_self') : navigate('/training/owned')}>
                          <div className="nav-title-xs">Training</div>
                          {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                        </div>
                        <hr className="bg-[#F0F0F0]" />
                        <div
                          className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                          onClick={() => currentPath.includes('training') ? window.open('/claim', '_self') : navigate('/claim')}>
                          <div className="nav-title-xs">Claim</div>
                          {/* <img src={idearArrowRight} className="" alt="arrow-right" /> */}
                        </div>
                      </div>
                      {/* <div
                        className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                        onClick={() => navigate('/privacy-policy')}>
                        <div className="nav-title-xs">Privacy & Policy</div>
                      </div> */}
                      {/* <div
                        className="menu-item flex p-4 justify-between hover:bg-gray-100 cursor-pointer"
                        onClick={() => navigate('/profile')}>
                        <div className="nav-title-xs">Login</div>
                        <img src={idearArrowRight} className="" alt="arrow-right" />
                      </div> */}
                    </div>
                  </div>
                )}                
            </OutsideClickHandler>
      </div>
    </div>
  )
}

NavBarFullNew.propTypes = {
  transparent: PropTypes.bool
}

export default NavBarFullNew
